(function () {
  'use strict';

  var STORAGE_PREFIX = 'rabitat_gift_choice_';
  var STORAGE_DISMISS_PREFIX = 'rabitat_gift_dismissed_';
  var drawerEl = null;
  var sectionId = null;
  var isOpen = false;
  var isRefreshing = false;
  var autoAddInProgress = false;
  var pendingRefreshOpts = null;
  var refreshPromise = null;
  var activeRefreshId = 0;
  var closeTimer = null;
  var freebieLightboxTimer = null;
  var freebieKeyboardBound = false;
  var boundSurfaces = new WeakSet();
  var refreshDebounceTimer = null;
  var fetchingDepth = 0;
  var fetchingBlankMode = false;
  var REFRESH_DEBOUNCE_MS = 50;
  var TRANSITION_MS = 300;
  var FREEBIE_LIGHTBOX_MS = 240;
  var lastKnownUnlockSort = null;
  var lastConfettiAt = 0;
  var CONFETTI_DEBOUNCE_MS = 1800;
  var afterCartRenderQueued = false;
  var tierDiscountInProgress = false;
  var lastTierDiscountAttempt = { code: '', at: 0 };
  var TIER_DISCOUNT_ATTEMPT_COOLDOWN_MS = 4000;
  var toastTimer = null;
  var PICK_NUDGE_PREFIX = 'rabitat_gift_pick_nudge_';

  function lockScroll() {
    document.documentElement.classList.add('rabitat-scroll-lock');
    document.body.classList.add('rabitat-scroll-lock');
  }

  function unlockScroll() {
    document.documentElement.classList.remove('rabitat-scroll-lock');
    document.body.classList.remove('rabitat-scroll-lock');
  }

  function getDrawer() {
    return document.querySelector('[data-cart-drawer]');
  }

  function getCartPage() {
    return document.querySelector('[data-cart-page]');
  }

  function getQueryRoot() {
    return getCartPage() || getDrawer();
  }

  function isOnCartPage() {
    return !!getCartPage();
  }

  function notifyCartUpdated(cart, meta) {
    document.dispatchEvent(new CustomEvent('cart:updated'));

    if (cart && typeof cart.item_count === 'number') {
      var detail = { item_count: cart.item_count, cart: cart };
      if (meta && meta.sectionsApplied) {
        detail.sectionsApplied = true;
      }
      document.dispatchEvent(
        new CustomEvent('rabitat:cart:updated', {
          detail: detail
        })
      );
    }
  }

  function getCartSectionIds() {
    var ids = [];
    var page = getCartPage();
    var drawer = getDrawer();

    if (page) {
      ids.push(page.getAttribute('data-section-id'));
    } else if (drawer) {
      ids.push(drawer.getAttribute('data-section-id'));
    }

    return ids.filter(Boolean);
  }

  function getCartSectionsUrl() {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return root + 'cart';
  }

  function withCartSections(body) {
    var payload = body || {};
    var ids = getCartSectionIds();
    if (!ids.length) return payload;

    payload.sections = ids.join(',');
    payload.sections_url = getCartSectionsUrl();
    return payload;
  }

  function resolveMutationItemCount(data, wasEmpty) {
    if (data && typeof data.item_count === 'number') {
      return data.item_count;
    }

    var fromSections = parseCartCountFromSections(data && data.sections);
    if (typeof fromSections === 'number' && fromSections > 0) {
      return fromSections;
    }

    if (wasEmpty) {
      var addedQty = data && typeof data.quantity === 'number' ? data.quantity : 1;
      var countEl = document.querySelector('[data-rabitat-cart-count]');
      if (countEl && !countEl.hidden) {
        var headerCount = parseInt(countEl.textContent, 10);
        if (!isNaN(headerCount) && headerCount > 0) {
          return headerCount;
        }
      }
      return addedQty;
    }

    return fromSections;
  }

  function mutationNeedsFilledDrawerRefresh(count) {
    if (typeof count !== 'number' || count <= 0) return false;

    var root = getQueryRoot();
    if (!root) return true;

    if (root.querySelector('[data-cart-drawer-empty]')) return true;
    if (!root.querySelector('[data-cart-progress]')) return true;

    return false;
  }

  function parseCartCountFromSections(sections) {
    if (!sections) return null;

    var ids = getCartSectionIds();
    for (var i = 0; i < ids.length; i++) {
      var html = sections[ids[i]];
      if (!html) continue;

      var doc = new DOMParser().parseFromString(html, 'text/html');
      var countEl =
        doc.querySelector('[data-cart-page-count]') ||
        doc.querySelector('.rabitat-cart-drawer__title-count');
      if (!countEl) continue;

      var count = parseInt(countEl.textContent, 10);
      if (!isNaN(count)) return count;
    }

    return null;
  }

  function getMutationApplyTargets() {
    var targets = [];
    var page = getCartPage();
    var drawer = getDrawer();

    if (page) {
      targets.push({
        root: page,
        kind: 'page',
        sectionId: page.getAttribute('data-section-id')
      });
    } else if (drawer) {
      targets.push({
        root: drawer,
        kind: 'drawer',
        sectionId: drawer.getAttribute('data-section-id')
      });
    }

    return targets.filter(function (target) {
      return target.root && target.sectionId;
    });
  }

  function getProgressCard() {
    var root = getQueryRoot();
    return root ? root.querySelector('[data-cart-progress]') : null;
  }

  function celebrateFreebie(reason) {
    if (!window.RabitatConfetti) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var now = Date.now();
    if (now - lastConfettiAt < CONFETTI_DEBOUNCE_MS) return;
    lastConfettiAt = now;

    var progress = getProgressCard();
    var opts = {
      particleCount: reason === 'unlock' ? 90 : 70,
      spread: 75
    };

    if (progress) {
      window.RabitatConfetti.burstFromElement(progress, opts);
    } else {
      window.RabitatConfetti.burst(opts);
    }
  }

  function checkTierUnlockCelebration() {
    var progress = getProgressCard();
    if (!progress) return;

    var current = parseInt(progress.getAttribute('data-highest-unlocked-sort'), 10) || 0;

    if (lastKnownUnlockSort === null) {
      lastKnownUnlockSort = current;
      return;
    }

    if (current > lastKnownUnlockSort) {
      celebrateFreebie('unlock');
      window.setTimeout(highlightGiftSection, 400);
    }

    lastKnownUnlockSort = current;
  }

  function showCartToast(message) {
    if (!message) return;

    var root = getDrawer() || getCartPage();
    if (!root) return;

    var toast = root.querySelector('[data-cart-toast]');
    if (!toast) return;

    toast.textContent = message;
    toast.hidden = false;

    if (toastTimer) {
      window.clearTimeout(toastTimer);
    }

    toastTimer = window.setTimeout(function () {
      toast.hidden = true;
      toast.textContent = '';
      toastTimer = null;
    }, 4200);
  }

  function buildAutoGiftToastMessage(items) {
    if (!items || !items.length) return '';

    var titles = items
      .map(function (item) {
        return item.title;
      })
      .filter(Boolean);

    if (!titles.length) {
      return items.length === 1 ? 'Free gift added to your cart' : 'Free gifts added to your cart';
    }

    if (titles.length === 1) {
      return 'Free gift added: ' + titles[0];
    }

    if (titles.length === 2) {
      return 'Free gifts added: ' + titles[0] + ' & ' + titles[1];
    }

    return 'Free gifts added: ' + titles[0] + ' +' + (titles.length - 1) + ' more';
  }

  function maybeNudgeManualPick() {
    var root = getQueryRoot();
    if (!root) return;

    var giftSection = root.querySelector('[data-cart-gift-section]');
    if (!giftSection) return;

    var pending = parseInt(giftSection.getAttribute('data-manual-pick-pending'), 10) || 0;
    if (pending !== 1) return;

    var token = giftSection.getAttribute('data-gift-token') || 'default';
    var storageKey = PICK_NUDGE_PREFIX + token;

    try {
      if (window.sessionStorage.getItem(storageKey) === '1') return;
      window.sessionStorage.setItem(storageKey, '1');
    } catch (error) {
      /* ignore storage failures */
    }

    giftSection.classList.add('is-nudge');
    highlightGiftSection();

    window.setTimeout(function () {
      giftSection.classList.remove('is-nudge');
    }, 2400);
  }

  function maybeCleanupIneligibleGifts() {
    if (autoAddInProgress || tierDiscountInProgress) {
      return Promise.resolve(false);
    }

    var root = getQueryRoot();
    if (!root) return Promise.resolve(false);

    var progress = root.querySelector('[data-cart-progress]');
    if (!progress) return Promise.resolve(false);
    if (progress.getAttribute('data-offer-threshold-mode') !== 'quantity') {
      return Promise.resolve(false);
    }

    var highestSort = parseInt(progress.getAttribute('data-highest-unlocked-sort'), 10) || 0;
    if (highestSort > 0) return Promise.resolve(false);

    var giftLines = root.querySelectorAll('[data-cart-gift-line]');
    if (!giftLines.length) return Promise.resolve(false);

    autoAddInProgress = true;

    var chain = Promise.resolve();
    giftLines.forEach(function (line, index) {
      var lineKey = line.getAttribute('data-line-key');
      if (!lineKey) return;

      chain = chain.then(function () {
        return changeLineQuantity(lineKey, 0, {
          skipHandle: index < giftLines.length - 1,
          silent: true
        });
      });
    });

    return chain
      .then(function () {
        return true;
      })
      .catch(function (error) {
        console.error('Ineligible gift cleanup failed:', error);
        return false;
      })
      .finally(function () {
        autoAddInProgress = false;
      });
  }

  function afterCartRender() {
    resetDismissForEligibleGifts();
    checkTierUnlockCelebration();
    maybeNudgeManualPick();
    maybeCleanupIneligibleGifts()
      .then(function () {
        return maybeCleanupStaleGifts();
      })
      .then(function () {
        return maybeApplyTierDiscount();
      })
      .then(function () {
        maybeAutoAddGift();
      });
  }

  function normalizeDiscountCode(code) {
    return String(code || '').trim().toLowerCase();
  }

  function getAppliedDiscountCode(root) {
    if (!root) return '';

    var progress = root.querySelector('[data-cart-progress]');
    if (progress) {
      var progressApplied = progress.getAttribute('data-applied-discount-code');
      if (progressApplied != null && String(progressApplied).trim()) {
        return String(progressApplied).trim();
      }
    }

    var discounts = root.querySelector('[data-cart-discounts]');
    if (discounts) {
      var discountApplied = String(discounts.getAttribute('data-applied-discount-code') || '').trim();
      if (discountApplied) return discountApplied;
    }

    var lineDiscountEls = root.querySelectorAll('[data-line-discount-codes]');
    for (var i = 0; i < lineDiscountEls.length; i++) {
      var lineCodes = String(lineDiscountEls[i].getAttribute('data-line-discount-codes') || '')
        .split(',')
        .map(function (code) {
          return String(code || '').trim();
        })
        .filter(Boolean);
      if (lineCodes.length) {
        return lineCodes[0];
      }
    }

    return '';
  }

  function isOfferDiscountApplied(root, desiredCode, offerCodes) {
    var desiredNormalized = normalizeDiscountCode(desiredCode);
    if (!desiredNormalized) return false;

    var appliedCode = getAppliedDiscountCode(root);
    if (normalizeDiscountCode(appliedCode) === desiredNormalized) {
      return true;
    }

    var lineDiscountEls = root.querySelectorAll('[data-line-discount-codes]');
    for (var i = 0; i < lineDiscountEls.length; i++) {
      var lineCodes = String(lineDiscountEls[i].getAttribute('data-line-discount-codes') || '')
        .split(',')
        .map(function (code) {
          return normalizeDiscountCode(code);
        })
        .filter(Boolean);

      if (lineCodes.indexOf(desiredNormalized) !== -1) {
        return true;
      }
    }

    return false;
  }

  function getOfferDiscountCodes(progressEl) {
    if (!progressEl) return [];

    return String(progressEl.getAttribute('data-offer-discount-codes') || '')
      .split(',')
      .map(function (code) {
        return normalizeDiscountCode(code);
      })
      .filter(Boolean);
  }

  function maybeApplyTierDiscount() {
    if (tierDiscountInProgress || autoAddInProgress || isRefreshing) {
      return Promise.resolve(false);
    }

    var root = getQueryRoot();
    if (!root) return Promise.resolve(false);

    var progress = root.querySelector('[data-cart-progress]');
    if (!progress) return Promise.resolve(false);

    var desiredCode = String(progress.getAttribute('data-tier-discount-code') || '').trim();
    var offerCodes = getOfferDiscountCodes(progress);
    var currentCode = getAppliedDiscountCode(root);
    var desiredNormalized = normalizeDiscountCode(desiredCode);
    var currentNormalized = normalizeDiscountCode(currentCode);

    if (!desiredCode) {
      if (!currentCode || offerCodes.indexOf(currentNormalized) === -1) {
        return Promise.resolve(false);
      }

      tierDiscountInProgress = true;
      return applyDiscountCode('')
        .then(function () {
          return refreshDrawer({ silent: true, immediate: true, force: true });
        })
        .catch(function (error) {
          console.error('Tier discount removal failed:', error);
        })
        .finally(function () {
          tierDiscountInProgress = false;
        });
    }

    if (isOfferDiscountApplied(root, desiredCode, offerCodes)) {
      return Promise.resolve(false);
    }

    if (desiredNormalized === currentNormalized) return Promise.resolve(false);

    if (currentCode && offerCodes.indexOf(currentNormalized) === -1) {
      return Promise.resolve(false);
    }

    var now = Date.now();
    if (
      lastTierDiscountAttempt.code === desiredNormalized &&
      now - lastTierDiscountAttempt.at < TIER_DISCOUNT_ATTEMPT_COOLDOWN_MS
    ) {
      return Promise.resolve(false);
    }

    lastTierDiscountAttempt = { code: desiredNormalized, at: now };

    tierDiscountInProgress = true;
    return applyDiscountCode(desiredCode)
      .then(function () {
        return refreshDrawer({ silent: true, immediate: true, force: true });
      })
      .catch(function (error) {
        console.error('Tier discount apply failed:', error);
      })
      .finally(function () {
        tierDiscountInProgress = false;
      });
  }

  function scheduleAfterCartRender() {
    if (afterCartRenderQueued) return;
    afterCartRenderQueued = true;

    window.requestAnimationFrame(function () {
      afterCartRenderQueued = false;
      afterCartRender();
    });
  }

  function warmOpenGiftPanelImages(dropdown) {
    if (!dropdown) return;

    dropdown.querySelectorAll('.rabitat-cart-drawer__gift-card-media img').forEach(function (img) {
      if (img.complete) return;
      img.loading = 'eager';
    });
  }

  function highlightGiftSection() {
    var root = getQueryRoot();
    if (!root) return;

    var giftSection = root.querySelector('[data-cart-gift-section]');
    if (!giftSection) return;

    giftSection.classList.add('is-highlight');
    giftSection.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

    window.setTimeout(function () {
      giftSection.classList.remove('is-highlight');
    }, 2400);
  }

  function focusGiftSection() {
    var root = getQueryRoot();
    if (!root) return;

    var giftSection = root.querySelector('[data-cart-gift-section]');
    if (!giftSection) return;

    highlightGiftSection();
    openGiftDropdown(giftSection);
  }

  function runPostCartMutationTasks() {
    return maybeCleanupStaleGifts().then(function (didCleanup) {
      if (!didCleanup) {
        scheduleAfterCartRender();
      }
    });
  }

  function applyCartSectionsFromMutation(data, opts) {
    var options = opts || {};
    var wasEmpty = isDrawerShowingEmpty();
    var count = resolveMutationItemCount(data, wasEmpty);

    if (typeof count === 'number') {
      updateCartCount(count);
    }

    openDrawerForAdd(options);

    if (data && data.sections) {
      var targets = getMutationApplyTargets();
      if (targets.length) {
        applyRefreshTargets(targets, data.sections, options);

        if (mutationNeedsFilledDrawerRefresh(count)) {
          return { applied: false, count: count, data: data };
        }

        notifyCartUpdated({ item_count: count, sections: data.sections }, { sectionsApplied: true });
        return { applied: true, count: count, data: data };
      }
    }

    return { applied: false, count: count, data: data };
  }

  function handleCartMutationResult(data, opts) {
    var options = opts || {};
    var result = applyCartSectionsFromMutation(data, options);

    if (result.applied) {
      return runPostCartMutationTasks().then(function () {
        return result.data;
      });
    }

    return refreshDrawer({
      immediate: true,
      force: true,
      open: options.open !== false && !isOnCartPage(),
      expectedCount: result.count
    }).then(function () {
      if (typeof result.count === 'number') {
        notifyCartUpdated({ item_count: result.count }, { sectionsApplied: true });
      }
      return result.data;
    });
  }

  function syncCartAfterAdd(lineItem) {
    return handleCartMutationResult(lineItem, {
      open: true,
      focus: false,
      animate: false
    });
  }

  function mergeRefreshOpts(existing, next) {
    if (!existing) return next || {};
    if (!next) return existing;

    return {
      open: existing.open || next.open,
      force: existing.force || next.force,
      focus: next.focus === false ? false : existing.focus !== false,
      expectedCount:
        typeof next.expectedCount === 'number'
          ? next.expectedCount
          : existing.expectedCount
    };
  }

  function getRefreshTargets(options) {
    var opts = options || {};
    var targets = [];
    var page = getCartPage();
    var drawer = getDrawer();

    if (page) {
      targets.push({
        root: page,
        kind: 'page',
        sectionId: page.getAttribute('data-section-id')
      });
      return targets.filter(function (target) {
        return target.root && target.sectionId;
      });
    }

    if (drawer) {
      targets.push({
        root: drawer,
        kind: 'drawer',
        sectionId: drawer.getAttribute('data-section-id')
      });
    }

    return targets.filter(function (target) {
      return target.root && target.sectionId;
    });
  }

  function buildSectionUrl(sectionIds) {
    var ids = Array.isArray(sectionIds) ? sectionIds : [sectionIds];
    var uniqueIds = ids.filter(function (id, index) {
      return id && ids.indexOf(id) === index;
    });

    return (
      getCartSectionsUrl() +
      '?sections=' +
      uniqueIds.map(function (id) {
        return encodeURIComponent(id);
      }).join(',') +
      '&_=' +
      Date.now()
    );
  }

  function updateCartCount(count) {
    if (typeof count !== 'number') return;

    document.querySelectorAll('[data-rabitat-cart-count]').forEach(function (countEl) {
      countEl.textContent = count;
      countEl.hidden = count <= 0;
    });

    var ariaLabel = count > 0 ? 'Cart, ' + count + ' item' + (count === 1 ? '' : 's') : 'Cart';
    document.querySelectorAll('[data-rabitat-cart-link]').forEach(function (link) {
      link.setAttribute('aria-label', ariaLabel);
    });

    var mobileCart = document.querySelector('[data-rabitat-mobile-cart]');
    if (mobileCart) {
      mobileCart.textContent = count > 0 ? 'Cart (' + count + ')' : 'Cart';
    }

    var drawer = getDrawer();
    if (drawer) {
      var drawerTitle = drawer.querySelector('.rabitat-cart-drawer__title');
      if (drawerTitle) {
        var drawerBadge = drawerTitle.querySelector('.rabitat-cart-drawer__title-count');
        if (count > 0) {
          if (!drawerBadge) {
            drawerBadge = document.createElement('span');
            drawerBadge.className = 'rabitat-cart-drawer__title-count';
            drawerTitle.appendChild(drawerBadge);
          }
          drawerBadge.textContent = count;
        } else if (drawerBadge) {
          drawerBadge.remove();
        }
      }
    }

    var page = getCartPage();
    if (!page) return;

    var pageTitle = page.querySelector('.rabitat-cart-page__title');
    if (!pageTitle) return;

    var pageBadge = pageTitle.querySelector('[data-cart-page-count]');
    if (count > 0) {
      if (!pageBadge) {
        pageBadge = document.createElement('span');
        pageBadge.className = 'rabitat-cart-page__title-count';
        pageBadge.setAttribute('data-cart-page-count', '');
        pageTitle.appendChild(pageBadge);
      }
      pageBadge.textContent = count;
    } else if (pageBadge) {
      pageBadge.remove();
    }
  }

  function openGiftDropdown(dropdown) {
    if (!dropdown) return;

    var toggle = dropdown.querySelector('[data-cart-gift-dropdown-toggle]');
    var panel = dropdown.querySelector('[data-cart-gift-dropdown-panel]');
    if (!toggle || !panel) return;

    toggle.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    dropdown.classList.add('is-open');
    warmOpenGiftPanelImages(dropdown);
  }

  function closeGiftDropdown(dropdown) {
    if (!dropdown) return;

    var toggle = dropdown.querySelector('[data-cart-gift-dropdown-toggle]');
    var panel = dropdown.querySelector('[data-cart-gift-dropdown-panel]');
    if (!toggle || !panel) return;

    toggle.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
    dropdown.classList.remove('is-open');
  }

  function closeAllGiftDropdowns(except) {
    document.querySelectorAll('[data-cart-gift-picker].is-open').forEach(function (dropdown) {
      if (except && dropdown === except) return;
      closeGiftDropdown(dropdown);
    });
  }

  function isDrawerShowingEmpty() {
    var drawer = getDrawer();
    return !!(drawer && drawer.querySelector('[data-cart-drawer-empty]'));
  }

  function shouldShowCartLoader(options) {
    if (isOnCartPage()) return true;

    var drawer = getDrawer();
    if (!drawer) return false;
    if (isOpen) return true;

    var opts = options || {};
    if (opts.open) return true;

    return drawer.getAttribute('data-open-on-add') === 'true';
  }

  function syncFetchingClasses() {
    var active = fetchingDepth > 0;
    var blank = active && fetchingBlankMode;
    var page = getCartPage();
    if (page) {
      page.classList.toggle('is-fetching', active);
      page.classList.toggle('is-fetching-blank', blank);
    }

    var drawer = getDrawer();
    if (drawer) {
      drawer.classList.toggle('is-fetching', active);
      drawer.classList.toggle('is-fetching-blank', blank);
    }
  }

  function pushFetchingState(blank) {
    fetchingDepth += 1;
    if (blank) fetchingBlankMode = true;
    syncFetchingClasses();
  }

  function popFetchingState() {
    fetchingDepth = Math.max(0, fetchingDepth - 1);
    if (fetchingDepth === 0) fetchingBlankMode = false;
    syncFetchingClasses();
  }

  function setFetchingState(active, blank) {
    if (active) {
      pushFetchingState(blank);
      return;
    }
    popFetchingState();
  }

  function shouldShowFetching(expectedCount) {
    if (!isDrawerShowingEmpty()) return false;
    if (typeof expectedCount === 'number' && expectedCount > 0) return false;

    var countEl = document.querySelector('[data-rabitat-cart-count]');
    if (!countEl || countEl.hidden) return false;
    return (parseInt(countEl.textContent, 10) || 0) > 0;
  }

  function swapDrawerPanel(nextDrawer) {
    var drawer = getDrawer();
    if (!drawer || !nextDrawer) return false;

    var currentPanel = drawer.querySelector('.rabitat-cart-drawer__panel');
    var nextPanel = nextDrawer.querySelector('.rabitat-cart-drawer__panel');
    if (!currentPanel || !nextPanel) return false;

    currentPanel.innerHTML = nextPanel.innerHTML;
    bindBreakupToggle(drawer);
    return true;
  }

  function swapCartPage(nextPage) {
    var page = getCartPage();
    if (!page || !nextPage) return false;

    page.innerHTML = nextPage.innerHTML;
    bindBreakupToggle(page);
    return true;
  }

  function applyRefreshTargets(targets, sections, options) {
    var opts = options || {};
    var wasDrawerEmpty = isDrawerShowingEmpty();
    var doc = new DOMParser().parseFromString('', 'text/html');

    targets.forEach(function (target) {
      var html = sections[target.sectionId];
      if (!html) return;

      doc = new DOMParser().parseFromString(html, 'text/html');

      if (target.kind === 'page') {
        var nextPage = doc.querySelector('[data-cart-page]');
        if (!nextPage) return;
        swapCartPage(nextPage);
        bindCartSurface(getCartPage());
        return;
      }

      var nextDrawer = doc.querySelector('[data-cart-drawer]');
      if (!nextDrawer) return;

      var swapped = swapDrawerPanel(nextDrawer);
      if (!swapped) {
        target.root.outerHTML = nextDrawer.outerHTML;
      }

      bindCartSurface(getDrawer());
    });

    if (wasDrawerEmpty && !isDrawerShowingEmpty()) {
      fetchingBlankMode = false;
      syncFetchingClasses();
      lastKnownUnlockSort = null;
    }

    if (getDrawer() && !isOnCartPage() && (isOpen || opts.open)) {
      ensureDrawerOpen({ focus: false, animate: false });
    }

    if (window.RabitatCartEdd && typeof window.RabitatCartEdd.refresh === 'function') {
      window.RabitatCartEdd.refresh();
    }
  }

  function openDrawerForAdd(options) {
    var opts = options || {};
    var drawer = getDrawer();
    if (!drawer || isOnCartPage()) return;

    if (opts.open || drawer.getAttribute('data-open-on-add') === 'true') {
      openCartDrawer({ focus: opts.focus !== false, animate: opts.animate !== false });
    }
  }

  function scheduleRefresh(options) {
    var opts = options || {};

    openDrawerForAdd(opts);

    if (typeof opts.expectedCount === 'number') {
      updateCartCount(opts.expectedCount);
    }

    pendingRefreshOpts = mergeRefreshOpts(pendingRefreshOpts, opts);

    if (refreshDebounceTimer) {
      window.clearTimeout(refreshDebounceTimer);
    }

    refreshDebounceTimer = window.setTimeout(function () {
      refreshDebounceTimer = null;
      var merged = pendingRefreshOpts || {};
      pendingRefreshOpts = null;
      merged.immediate = true;
      refreshDrawer(merged);
    }, REFRESH_DEBOUNCE_MS);

    return refreshPromise || Promise.resolve();
  }

  function runRefresh(options) {
    var opts = options || {};
    var refreshId = ++activeRefreshId;
    var targets = getRefreshTargets(opts);

    if (!targets.length) {
      return Promise.resolve();
    }

    var expectedCount = typeof opts.expectedCount === 'number' ? opts.expectedCount : null;
    var showBlankFetching = shouldShowFetching(expectedCount);
    var drawer = getDrawer();

    if (opts.open && drawer && !isOpen && !isOnCartPage()) {
      openCartDrawer({ focus: opts.focus !== false, animate: false });
    }

    if (shouldShowCartLoader(opts)) {
      pushFetchingState(showBlankFetching);
    }

    isRefreshing = true;

    var sectionIds = targets.map(function (target) {
      return target.sectionId;
    });

    return fetch(buildSectionUrl(sectionIds), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        if (refreshId !== activeRefreshId) return null;
        if (!response.ok) throw new Error('Section request failed');
        return response.json();
      })
      .then(function (sections) {
        if (!sections || refreshId !== activeRefreshId) return null;
        applyRefreshTargets(targets, sections, opts);
        if (shouldShowCartLoader(opts)) {
          popFetchingState();
        }
        return maybeCleanupStaleGifts();
      })
      .then(function (didCleanup) {
        if (refreshId !== activeRefreshId) return;
        if (didCleanup === null) return;
        if (!didCleanup) {
          scheduleAfterCartRender();
          return;
        }
      })
      .catch(function (error) {
        if (refreshId !== activeRefreshId) return;
        console.error('Cart refresh failed:', error);
      })
      .finally(function () {
        if (refreshId !== activeRefreshId) return;

        isRefreshing = false;
        if (shouldShowCartLoader(opts) && fetchingDepth > 0) {
          popFetchingState();
        }

        if (pendingRefreshOpts) {
          var queued = pendingRefreshOpts;
          pendingRefreshOpts = null;
          refreshPromise = runRefresh(queued);
        } else {
          refreshPromise = null;
        }
      });
  }

  function refreshDrawer(options) {
    var opts = options || {};
    var drawer = getDrawer();
    var page = getCartPage();

    if (!drawer && !page) {
      return Promise.resolve();
    }

    if (!opts.immediate && !opts.force) {
      return scheduleRefresh(opts);
    }

    if (refreshDebounceTimer) {
      window.clearTimeout(refreshDebounceTimer);
      refreshDebounceTimer = null;
    }

    if (isRefreshing && !opts.force) {
      pendingRefreshOpts = mergeRefreshOpts(pendingRefreshOpts, opts);
      return refreshPromise || Promise.resolve();
    }

    pendingRefreshOpts = null;
    refreshPromise = runRefresh(opts);
    return refreshPromise;
  }

  function changeLineQuantity(lineKey, quantity, options) {
    var opts = options || {};
    var shouldLoad = !opts.silent && !opts.skipHandle && shouldShowCartLoader();

    if (shouldLoad) {
      pushFetchingState(false);
    }

    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(withCartSections({ id: lineKey, quantity: quantity }))
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) {
            throw err;
          });
        }
        return response.json();
      })
      .then(function (cart) {
        if (opts.skipHandle) return cart;

        var result = applyCartSectionsFromMutation(cart, {
          open: !isOnCartPage() && opts.open !== false,
          focus: false,
          animate: false
        });

        if (shouldLoad) {
          popFetchingState();
        }

        if (result.applied) {
          return runPostCartMutationTasks().then(function () {
            return cart;
          });
        }

        return handleCartMutationResult(cart, {
          open: !isOnCartPage() && opts.open !== false,
          focus: false,
          animate: false
        });
      })
      .finally(function () {
        if (shouldLoad && fetchingDepth > 0) {
          popFetchingState();
        }
      });
  }

  function addGiftVariant(variantId, giftToken) {
    return addGiftVariants([{ variantId: variantId, giftToken: giftToken }]);
  }

  function findGiftLineElement(giftToken) {
    var root = getQueryRoot();
    if (!root || !giftToken) return null;

    var tierKey = giftToken.indexOf('::') !== -1 ? giftToken.split('::').pop() : '';
    var lines = root.querySelectorAll('[data-cart-gift-line]');

    for (var i = 0; i < lines.length; i++) {
      var line = lines[i];
      var token = line.getAttribute('data-gift-token') || '';
      if (token === giftToken || (tierKey && token === tierKey)) {
        return line;
      }
    }

    return null;
  }

  function replaceGiftVariant(variantId, giftToken) {
    var existingLine = findGiftLineElement(giftToken);
    var existingVariantId = existingLine ? existingLine.getAttribute('data-variant-id') : null;

    if (existingVariantId && existingVariantId === String(variantId)) {
      return Promise.resolve();
    }

    if (existingLine) {
      var lineKey = existingLine.getAttribute('data-line-key');
      if (lineKey) {
        return changeLineQuantity(lineKey, 0, { silent: true, skipHandle: true }).then(function () {
          return addGiftVariant(variantId, giftToken);
        });
      }
    }

    return addGiftVariant(variantId, giftToken);
  }

  function addGiftVariants(items, options) {
    if (!items || !items.length) return Promise.resolve();

    var opts = options || {};
    var payloadItems = items
      .map(function (item) {
        return {
          id: Number(item.variantId),
          quantity: 1,
          properties: {
            _gift: item.giftToken
          }
        };
      })
      .filter(function (item) {
        return item.id;
      });

    if (!payloadItems.length) return Promise.resolve();

    var shouldLoad = !opts.silent && shouldShowCartLoader();

    if (shouldLoad) {
      pushFetchingState(false);
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(
        withCartSections({
          items: payloadItems
        })
      )
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) {
            throw err;
          });
        }
        return response.json();
      })
      .then(function (data) {
        items.forEach(function (item) {
          rememberGiftChoice(item.giftToken, item.variantId);
        });
        if (!opts.silent) {
          celebrateFreebie('add');
        }

        var result = applyCartSectionsFromMutation(data, {
          open: !isOnCartPage(),
          focus: false,
          animate: false
        });

        if (shouldLoad) {
          popFetchingState();
        }

        if (result.applied) {
          return runPostCartMutationTasks().then(function () {
            return data;
          });
        }

        return handleCartMutationResult(data, {
          open: !isOnCartPage(),
          focus: false,
          animate: false
        });
      })
      .finally(function () {
        if (shouldLoad && fetchingDepth > 0) {
          popFetchingState();
        }
      });
  }

  function rememberGiftChoice(giftToken, variantId) {
    try {
      window.localStorage.setItem(STORAGE_PREFIX + giftToken, String(variantId));
      window.localStorage.removeItem(STORAGE_DISMISS_PREFIX + giftToken);
    } catch (error) {
      /* ignore storage failures */
    }
  }

  function clearGiftStorage(giftToken) {
    try {
      window.localStorage.removeItem(STORAGE_PREFIX + giftToken);
      window.localStorage.removeItem(STORAGE_DISMISS_PREFIX + giftToken);
    } catch (error) {
      /* ignore storage failures */
    }
  }

  function resetGiftDismissals(giftToken) {
    try {
      window.localStorage.removeItem(STORAGE_DISMISS_PREFIX + giftToken);
    } catch (error) {
      /* ignore storage failures */
    }
  }

  function isGiftDismissed(giftToken) {
    try {
      return window.localStorage.getItem(STORAGE_DISMISS_PREFIX + giftToken) === '1';
    } catch (error) {
      return false;
    }
  }

  function resetDismissForEligibleGifts() {
    var root = getQueryRoot();
    if (!root) return;

    var resetEl = root.querySelector('[data-cart-gift-reset-dismiss]');
    if (!resetEl) return;

    var tokens = (resetEl.getAttribute('data-tokens') || '')
      .split(',')
      .map(function (token) {
        return token.trim();
      })
      .filter(Boolean);

    tokens.forEach(resetGiftDismissals);
  }

  function updateDiscountError(message) {
    var root = getQueryRoot();
    if (!root) return;

    var errorEl = root.querySelector('[data-cart-discount-error]');
    if (!errorEl) return;

    if (message) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    } else {
      errorEl.textContent = '';
      errorEl.hidden = true;
    }
  }

  function applyDiscountCode(code) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ discount: code })
    }).then(function (response) {
      return response.json().then(function (payload) {
        if (!response.ok) {
          throw payload;
        }
        return payload;
      });
    });
  }

  function maybeCleanupStaleGifts() {
    var root = getQueryRoot();
    if (!root || autoAddInProgress) return Promise.resolve(false);

    var cleanupEl = root.querySelector('[data-cart-gift-cleanup]');
    if (!cleanupEl) return Promise.resolve(false);

    var keysStr = cleanupEl.getAttribute('data-line-keys') || '';
    var keys = keysStr.split(',').map(function (key) {
      return key.trim();
    }).filter(Boolean);

    if (!keys.length) return Promise.resolve(false);

    var clearTokens = (cleanupEl.getAttribute('data-clear-tokens') || '')
      .split(',')
      .map(function (token) {
        return token.trim();
      })
      .filter(Boolean);

    clearTokens.forEach(clearGiftStorage);

    var resetTokens = (cleanupEl.getAttribute('data-reset-tokens') || '')
      .split(',')
      .map(function (token) {
        return token.trim();
      })
      .filter(Boolean);

    resetTokens.forEach(resetGiftDismissals);

    autoAddInProgress = true;

    var chain = Promise.resolve();
    keys.forEach(function (lineKey, index) {
      chain = chain.then(function () {
        return changeLineQuantity(lineKey, 0, {
          skipHandle: index < keys.length - 1,
          silent: true
        });
      });
    });

    return chain
      .then(function () {
        return true;
      })
      .catch(function (error) {
        console.error('Stale gift cleanup failed:', error);
        return false;
      })
      .finally(function () {
        autoAddInProgress = false;
      });
  }

  function maybeAutoAddGift() {
    var root = getQueryRoot();
    if (!root || autoAddInProgress) return;

    var progress = root.querySelector('[data-cart-progress]');
    if (progress) {
      var highestUnlockedSort = parseInt(progress.getAttribute('data-highest-unlocked-sort'), 10) || 0;
      if (highestUnlockedSort <= 0) return;
    }

    var autoEls = root.querySelectorAll('[data-cart-gift-auto]');
    if (!autoEls.length) return;

    var items = [];
    autoEls.forEach(function (autoEl) {
      var variantId = autoEl.getAttribute('data-variant-id');
      var giftToken = autoEl.getAttribute('data-gift-token');
      if (!variantId || !giftToken || isGiftDismissed(giftToken)) return;
      if (findGiftLineElement(giftToken)) return;

      items.push({
        variantId: variantId,
        giftToken: giftToken,
        title: autoEl.getAttribute('data-gift-title') || ''
      });
    });

    if (!items.length) return;

    autoAddInProgress = true;

    addGiftVariants(items, { silent: true })
      .then(function () {
        var toastMessage = buildAutoGiftToastMessage(items);
        if (toastMessage) {
          showCartToast(toastMessage);
        }
      })
      .catch(function (error) {
        console.error('Auto gift add failed:', error);
      })
      .finally(function () {
        autoAddInProgress = false;
      });
  }

  function ensureDrawerOpen(options) {
    var opts = options || {};
    var drawer = getDrawer();
    if (!drawer) return;

    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimer = null;
    }

    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');

    if (!drawer.classList.contains('is-open')) {
      if (opts.animate !== false) {
        void drawer.offsetWidth;
      }
      drawer.classList.add('is-open');
    }

    isOpen = true;
    lockScroll();

    window.setTimeout(scheduleAfterCartRender, 0);

    if (opts.focus !== false) {
      var closeBtn = drawer.querySelector('[data-cart-drawer-close]');
      if (closeBtn) closeBtn.focus();
    }
  }

  function openCartDrawer(options) {
    ensureDrawerOpen(options);
  }

  function closeCartDrawer() {
    var drawer = getDrawer();
    if (!drawer || !isOpen) return;

    closeFreebieLightbox();

    if (typeof window.rabitatResetSafariZoom === 'function') {
      window.rabitatResetSafariZoom();
    }

    drawer.classList.remove('is-open');
    isOpen = false;
    unlockScroll();

    if (closeTimer) {
      window.clearTimeout(closeTimer);
    }

    var finishClose = function () {
      if (isOpen || !drawer) return;
      drawer.hidden = true;
      drawer.setAttribute('aria-hidden', 'true');
      closeTimer = null;
      if (typeof window.rabitatResetSafariZoom === 'function') {
        window.rabitatResetSafariZoom();
      }
    };

    var panel = drawer.querySelector('.rabitat-cart-drawer__panel');
    if (panel) {
      var onEnd = function (event) {
        if (event.target !== panel || event.propertyName !== 'transform') return;
        panel.removeEventListener('transitionend', onEnd);
        finishClose();
      };
      panel.addEventListener('transitionend', onEnd);
    }

    closeTimer = window.setTimeout(finishClose, TRANSITION_MS + 50);
  }

  function getFirstAvailableVariantId(data) {
    if (!data || !data.variants || !data.variants.length) return null;
    for (var i = 0; i < data.variants.length; i++) {
      if (data.variants[i].available) return data.variants[i].id;
    }
    return data.variants[0].id;
  }

  function readUpsellJson(el) {
    if (!el) return '';
    if (el.tagName === 'SCRIPT') {
      return (el.textContent || el.innerHTML || '').trim();
    }
    if (el.tagName === 'TEMPLATE') {
      if (el.content && el.content.textContent) {
        return el.content.textContent.trim();
      }
      return (el.innerHTML || '').trim();
    }
    return (el.textContent || '').trim();
  }

  function openUpsellQuickAdd(card) {
    var jsonEl = card.querySelector('[data-cart-upsell-json]');
    if (!jsonEl) return;

    try {
      var rawJson = readUpsellJson(jsonEl);
      if (!rawJson) return;

      var quickAddData = JSON.parse(rawJson);
      if (!quickAddData || !quickAddData.variants || !quickAddData.variants.length) return;

      var variantId = getFirstAvailableVariantId(quickAddData);

      if (window.RabitatQuickAdd && typeof window.RabitatQuickAdd.open === 'function') {
        window.RabitatQuickAdd.open(quickAddData, variantId);
        return;
      }

      document.dispatchEvent(
        new CustomEvent('rabitat:quick-add:open', {
          detail: {
            data: quickAddData,
            variantId: variantId
          }
        })
      );
    } catch (error) {
      console.error('Cart upsell quick add parse error:', error);
    }
  }

  function openLinePersonaliseQuickAdd(lineEl, trigger) {
    var jsonEl = lineEl.querySelector('[data-cart-line-quick-add-json]');
    if (!jsonEl || !trigger) return;

    try {
      var rawJson = readUpsellJson(jsonEl);
      if (!rawJson) return;

      var quickAddData = JSON.parse(rawJson);
      if (!quickAddData || !quickAddData.variants || !quickAddData.variants.length) return;

      var variantId = trigger.getAttribute('data-variant-id');
      var lineKey = trigger.getAttribute('data-line-key');
      var quantity = parseInt(trigger.getAttribute('data-quantity'), 10) || 1;
      var options = {
        lineKey: lineKey,
        quantity: quantity
      };

      if (window.RabitatQuickAdd && typeof window.RabitatQuickAdd.open === 'function') {
        window.RabitatQuickAdd.open(quickAddData, variantId, options);
        return;
      }

      document.dispatchEvent(
        new CustomEvent('rabitat:quick-add:open', {
          detail: {
            data: quickAddData,
            variantId: variantId,
            options: options
          }
        })
      );
    } catch (error) {
      console.error('Cart line personalise quick add parse error:', error);
    }
  }

  function bindBreakupToggle(root) {
    var toggle = root.querySelector('[data-cart-breakup-toggle]');
    var panel = root.querySelector('[data-cart-breakup]');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', function () {
      var isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
      panel.hidden = isExpanded;
    });
  }

  function getFreebieLightbox(root) {
    root = root || getCartPage() || getDrawer();
    return root ? root.querySelector('[data-cart-freebie-lightbox]') : null;
  }

  function openFreebieLightbox(imageUrl, title, root) {
    root = root || getCartPage() || getDrawer();
    if (!root || !imageUrl) return;

    var lightbox = getFreebieLightbox(root);
    if (!lightbox) return;

    var imageEl = lightbox.querySelector('[data-cart-freebie-lightbox-image]');
    var titleEl = lightbox.querySelector('[data-cart-freebie-lightbox-title]');

    if (imageEl) {
      imageEl.src = imageUrl;
      imageEl.alt = title || 'Free gift';
    }

    if (titleEl) {
      if (title) {
        titleEl.textContent = title;
        titleEl.hidden = false;
      } else {
        titleEl.textContent = '';
        titleEl.hidden = true;
      }
    }

    lightbox.hidden = false;
    lightbox.setAttribute('aria-hidden', 'false');

    if (freebieLightboxTimer) {
      window.clearTimeout(freebieLightboxTimer);
      freebieLightboxTimer = null;
    }

    void lightbox.offsetWidth;
    lightbox.classList.add('is-open');

    var closeBtn = lightbox.querySelector('.rabitat-cart-drawer__freebie-lightbox-close');
    if (closeBtn) closeBtn.focus();
  }

  function closeFreebieLightbox() {
    [getCartPage(), getDrawer()].forEach(function (root) {
      if (!root) return;

      var lightbox = getFreebieLightbox(root);
      if (!lightbox || lightbox.hidden) return;

      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');

      if (freebieLightboxTimer) {
        window.clearTimeout(freebieLightboxTimer);
      }

      freebieLightboxTimer = window.setTimeout(function () {
        lightbox.hidden = true;
        var imageEl = lightbox.querySelector('[data-cart-freebie-lightbox-image]');
        if (imageEl) {
          imageEl.removeAttribute('src');
          imageEl.alt = 'Product preview';
        }
        freebieLightboxTimer = null;
      }, FREEBIE_LIGHTBOX_MS);
    });
  }

  function bindFreebieLightboxKeyboard() {
    if (freebieKeyboardBound) return;
    freebieKeyboardBound = true;

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;

      var openLightbox = null;
      [getCartPage(), getDrawer()].some(function (root) {
        if (!root) return false;
        var lightbox = getFreebieLightbox(root);
        if (lightbox && !lightbox.hidden && lightbox.classList.contains('is-open')) {
          openLightbox = lightbox;
          return true;
        }
        return false;
      });

      if (!openLightbox) return;

      event.preventDefault();
      event.stopPropagation();
      closeFreebieLightbox();
    });
  }

  function bindCartSurface(surface) {
    if (!surface || boundSurfaces.has(surface)) return;

    boundSurfaces.add(surface);

    if (surface.hasAttribute('data-cart-drawer')) {
      drawerEl = surface;
      sectionId = surface.getAttribute('data-section-id');
    }

    bindBreakupToggle(surface);

    surface.addEventListener('click', function (event) {
      if (event.target.closest('[data-cart-freebie-lightbox-close]')) {
        event.preventDefault();
        closeFreebieLightbox();
        return;
      }

      var freebiePreview = event.target.closest('[data-cart-freebie-preview]');
      if (freebiePreview) {
        event.preventDefault();
        var imageUrl = freebiePreview.getAttribute('data-freebie-image');
        var title = freebiePreview.getAttribute('data-freebie-title') || '';
        if (imageUrl) openFreebieLightbox(imageUrl, title, surface);
        return;
      }

      if (event.target.closest('[data-cart-drawer-close]')) {
        event.preventDefault();
        closeCartDrawer();
        return;
      }

      var upsellAddBtn = event.target.closest('[data-cart-upsell-add]');
      if (upsellAddBtn) {
        event.preventDefault();
        event.stopPropagation();
        var upsellCard = upsellAddBtn.closest('[data-cart-upsell-item]');
        if (upsellCard) openUpsellQuickAdd(upsellCard);
        return;
      }

      var personaliseBtn = event.target.closest('[data-cart-line-personalise]');
      if (personaliseBtn) {
        event.preventDefault();
        event.stopPropagation();
        var cartLine = personaliseBtn.closest('[data-cart-line]');
        if (cartLine) openLinePersonaliseQuickAdd(cartLine, personaliseBtn);
        return;
      }

      var qtyBtn = event.target.closest('[data-cart-qty-change]');
      if (qtyBtn) {
        event.preventDefault();
        var lineKey = qtyBtn.getAttribute('data-line-key');
        var delta = parseInt(qtyBtn.getAttribute('data-cart-qty-change'), 10);
        var qtyWrap = qtyBtn.closest('[data-cart-qty-wrap]');
        if (qtyWrap && qtyWrap.dataset.qtyPending === '1') return;

        var qtyValueEl = qtyWrap ? qtyWrap.querySelector('[data-cart-qty-value]') : null;
        var currentQty = qtyValueEl ? parseInt(qtyValueEl.textContent, 10) || 1 : 1;
        var nextQty = Math.max(0, currentQty + delta);

        if (qtyWrap) {
          qtyWrap.dataset.qtyPending = '1';
        }

        if (qtyValueEl) {
          qtyValueEl.textContent = nextQty;
        }

        changeLineQuantity(lineKey, nextQty)
          .catch(function (error) {
            if (qtyValueEl) {
              qtyValueEl.textContent = currentQty;
            }
            console.error('Quantity change failed:', error);
          })
          .finally(function () {
            if (qtyWrap) {
              delete qtyWrap.dataset.qtyPending;
            }
          });
        return;
      }

      var giftToggle = event.target.closest('[data-cart-gift-dropdown-toggle]');
      if (giftToggle) {
        event.preventDefault();
        var giftDropdown = giftToggle.closest('[data-cart-gift-picker]');
        if (!giftDropdown) return;

        var isOpen = giftDropdown.classList.contains('is-open');
        closeAllGiftDropdowns(giftDropdown);
        if (isOpen) {
          closeGiftDropdown(giftDropdown);
        } else {
          openGiftDropdown(giftDropdown);
        }
        return;
      }

      var giftAddBtn = event.target.closest('[data-cart-gift-add]');
      if (giftAddBtn) {
        event.preventDefault();
        if (surface.querySelector('[data-cart-gift-cleanup]')) return;

        var variantId = giftAddBtn.getAttribute('data-variant-id');
        var giftToken = giftAddBtn.getAttribute('data-gift-token');
        if (!variantId || !giftToken) return;

        giftAddBtn.disabled = true;

        replaceGiftVariant(variantId, giftToken)
          .then(function () {
            rememberGiftChoice(giftToken, variantId);
            var giftDropdown = giftAddBtn.closest('[data-cart-gift-picker]');
            closeGiftDropdown(giftDropdown);
          })
          .catch(function (error) {
            console.error('Gift add failed:', error);
            giftAddBtn.disabled = false;
          });
        return;
      }

      var discountRemoveBtn = event.target.closest('[data-cart-discount-remove]');
      if (discountRemoveBtn) {
        event.preventDefault();
        discountRemoveBtn.disabled = true;
        var discountShouldLoad = shouldShowCartLoader();
        if (discountShouldLoad) {
          pushFetchingState(false);
        }
        applyDiscountCode('')
          .then(function (cart) {
            updateDiscountError('');
            notifyCartUpdated(cart);
            return refreshDrawer({ open: !isOnCartPage() });
          })
          .catch(function (error) {
            console.error('Discount remove failed:', error);
            discountRemoveBtn.disabled = false;
          })
          .finally(function () {
            if (discountShouldLoad) {
              popFetchingState();
            }
          });
        return;
      }
    });
  }

  function ensureDrawerClosedOnCartPage() {
    if (!isOnCartPage()) return;

    var drawer = getDrawer();
    if (!drawer) return;

    closeFreebieLightbox();
    drawer.classList.remove('is-open');
    drawer.hidden = true;
    drawer.setAttribute('aria-hidden', 'true');
    isOpen = false;
    unlockScroll();
  }

  function interceptCartLinks() {
    document.addEventListener('click', function (event) {
      var cartLink = event.target.closest('[data-rabitat-cart-link]');
      if (!cartLink) return;

      event.preventDefault();

      if (isOnCartPage()) {
        ensureDrawerClosedOnCartPage();
        window.location.reload();
        return;
      }

      if (!getDrawer()) return;

      openCartDrawer({ animate: true });
      refreshDrawer({ open: true, focus: false, expectedCount: null });
    });
  }

  function bindCartUpdatedEvents() {
    document.addEventListener('rabitat:cart:updated', function (event) {
      var drawer = getDrawer();
      var page = getCartPage();
      if (!drawer && !page) return;

      var detail = event.detail || {};
      if (detail.sectionsApplied) return;

      var itemCount = typeof detail.item_count === 'number' ? detail.item_count : null;

      if (page) {
        refreshDrawer({
          open: false,
          focus: false,
          expectedCount: itemCount
        });
        return;
      }

      if (!drawer) return;

      var shouldOpen = drawer.getAttribute('data-open-on-add') === 'true';
      refreshDrawer({
        open: shouldOpen || isOpen,
        focus: false,
        expectedCount: itemCount
      });
    });
  }

  function init() {
    var drawer = getDrawer();
    var page = getCartPage();

    if (!drawer && !page) return;

    if (page) {
      ensureDrawerClosedOnCartPage();
      bindCartSurface(page);
      window.setTimeout(scheduleAfterCartRender, 0);
    }

    if (drawer) {
      bindCartSurface(drawer);
      window.setTimeout(scheduleAfterCartRender, 0);
    }

    bindFreebieLightboxKeyboard();
    interceptCartLinks();
    bindCartUpdatedEvents();

    if (!window.__rabitatGiftDropdownBound) {
      window.__rabitatGiftDropdownBound = true;
      document.addEventListener('click', function (event) {
        if (event.target.closest('[data-cart-gift-dropdown-toggle], [data-cart-gift-dropdown-panel]')) return;
        closeAllGiftDropdowns();
      });
    }

    window.openCartDrawer = openCartDrawer;
    window.closeCartDrawer = closeCartDrawer;
    window.refreshCartDrawer = refreshDrawer;

    window.RabitatCart = window.RabitatCart || {};
    window.RabitatCart.notifyUpdated = notifyCartUpdated;
    window.RabitatCart.updateCartCount = updateCartCount;
    window.RabitatCart.openDrawerForAdd = openDrawerForAdd;
    window.RabitatCart.withCartSections = withCartSections;
    window.RabitatCart.handleMutationResult = handleCartMutationResult;
    window.RabitatCart.syncCartAfterAdd = syncCartAfterAdd;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('[data-cart-drawer]') || event.target.querySelector('[data-cart-page]')) {
      init();
    }
  });
})();
